import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import AssignTypeModal from "../../modals/AssignTypeModal";
import SystemMessageModal from "../../modals/SystemMessageModal";
import SystemRejectModal from "../../modals/SystemRejectModal";
import { ADMIN, UPLOADS_URL } from "../../config/constants/api";
import { Put } from "../../config/api/put";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const DriverDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [rejectionReason, setRejectionReason] = useState("");
  const [systemMessageModal1, setSystemMessageModal1] = useState(false);
  const [systemMessageModal2, setSystemMessageModal2] = useState(false);
  const [systemRejectModal, setSystemRejectModal] = useState(false);
  const [assignTypeModal, setAssignTypeModal] = useState(false);
  const location = useLocation();
  const request = location?.state?.request;
  useEffect(() => {
    if (!request) {
      navigate(-1);
    }
    // eslint-disable-next-line
  }, []);
  const token = useSelector((state) => state.user.userToken);
  const beforeBanUser = () => {
    setSystemRejectModal(true);
  };

  const banUser = (status) => {
    let body = {
      status,
    };
    if (status === "REJECTED") {
      body = {
        status,
        rejectionReason,
      };
    }
    Put(`${ADMIN.validateChauffeurRequest}${id}`, token, body)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          navigate("/ChauffeurRequestList");
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between mx-1 lg:mx-8 mb-4">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Chauffeur Request Details
              </h3>
            </div>
          </div>
          <Row justify="center">
            <Col xs={23}>
              <Row justify="center" gutter={[32, 16]} className="mb-6">
                <Col lg={12} xs={22}>
                  <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6 h-full">
                    <h5 className="w-full text-start pl-8 mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                      Personal Information
                    </h5>
                    {request.image && (
                      <img
                        style={{
                          height: "180px",
                          width: "180px",
                          borderRadius: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                        }}
                        src={UPLOADS_URL + request?.image}
                        alt="profile"
                      />
                    )}

                    <div className="flex justify-center items-center my-4 mx-2">
                      <div className="flex flex-col items-start 2xl:mr-32 mr-6">
                        {(request.firstName || request.lastName) && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Full Name
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {request.firstName} {request.lastName}
                            </p>
                          </>
                        )}
                        {request?.phone && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Contact Number
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              +12 345 6789
                            </p>
                          </>
                        )}
                        {request?.dateOfBirth && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Birthday
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {extractDate(request?.dateOfBirth)}
                            </p>
                          </>
                        )}
                        {request?.licenseExpiryDate && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Driving license Expiry Date
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {extractDate(request?.licenseExpiryDate)}
                            </p>
                          </>
                        )}
                      </div>
                      <div className="flex flex-col items-start">
                        {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Email Address
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          sarah@email.com
                        </p> */}
                        {request.gender && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Gender
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              Male
                            </p>
                          </>
                        )}
                        {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                          Sex Orientation
                        </h5>
                        <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          Straight
                        </p> */}
                        {request?.drivingLicenseNo && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Driving License No.
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {request?.drivingLicenseNo}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={12} xs={22}>
                  <div className="flex flex-col items-center justify-center h-full w-full">
                    {(request?.bankTitle || request.bankAccountNo || request?.routingNo) && (
                      <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:py-8 py-6 pl-8 mb-8 w-full h-full">
                        <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                          Payment Info
                        </h5>
                        {request?.bankTitle && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Name of Bank
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {request?.bankTitle}
                            </p>
                          </>
                        )}
                        {request.bankAccountNo && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Bank Account No.
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                              {request.bankAccountNo}
                            </p>
                          </>
                        )}
                        {request?.routingNo && (
                          <>
                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                              Routing Number
                            </h5>
                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-0">
                              {request.routingNo}
                            </p>
                          </>
                        )}
                      </div>
                    )}
                    {(request?.dmvFront ||
                      request?.dmvBack ||
                      request?.tlcFront ||
                      request?.tlcBack ||
                      request?.insurance ||
                      request?.registeration ||
                      request?.licenseFront ||
                      request?.licenseBack) && (
                      <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:py-8 py-6 pl-8 pr-12 w-full h-full">
                        <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                          Documents
                        </h5>
                        <Row gutter={[16, 16]} style={{ width: "100%" }}>
                          {request?.licenseFront && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  License Front
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.licenseFront}
                                  alt="license front"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.licenseBack && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  License Back
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.licenseBack}
                                  alt="license back"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.dmvFront && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  DMV Front
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.dmvFront}
                                  alt="dmv front"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.dmvBack && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  DMV Back
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.dmvBack}
                                  alt="dmv back"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.tlcFront && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  TLC Front
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.tlcFront}
                                  alt="tlc front"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.tlcBack && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  TLC Back
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.tlcBack}
                                  alt="tlc back"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.insurance && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  Insurance
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.insurance}
                                  alt="insurance"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                          {request?.registeration && (
                            <Col lg={12} xs={24}>
                              <div className="flex flex-col items-start justify-center w-full">
                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2 ml-1">
                                  Registration
                                </h5>
                                <img
                                  src={UPLOADS_URL + request?.registeration}
                                  alt="registration"
                                  style={{
                                    width: "100%",
                                    height: "180px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </Col>
                          )}
                        </Row>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              <div className="flex justify-start items-center max-lg:ml-6">
                <button
                  className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                  //   onClick={() => navigate("/proveDriver")}
                  onClick={() => banUser("APPROVED")}
                >
                  Approve
                </button>
                <button
                  className="uppercase bg-transparent py-4 px-6 xl:px-16 text-black border-2 border-black rounded-lg font-semibold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                  onClick={beforeBanUser}
                >
                  Reject
                </button>
              </div>
            </Col>
          </Row>

          {systemMessageModal2 && (
            <SystemMessageModal
              systemMessageModal={systemMessageModal2}
              setSystemMessageModal={setSystemMessageModal2}
              message={"Driver Update request has been rejected successfully"}
              path={-1}
            />
          )}
          {systemMessageModal1 && (
            <SystemMessageModal
              systemMessageModal={systemMessageModal1}
              setSystemMessageModal={setSystemMessageModal1}
              message={"Car changes request approved successfully"}
              path={-1}
            />
          )}
          {systemRejectModal && (
            <SystemRejectModal
              systemRejectModal={systemRejectModal}
              setSystemRejectModal={setSystemRejectModal}
              setSystemMessageModal={setSystemMessageModal2}
              banUser={banUser}
              setRejectionReason={setRejectionReason}
              rejectionReason={rejectionReason}
            />
          )}
          {assignTypeModal && (
            <AssignTypeModal
              assignTypeModal={assignTypeModal}
              setAssignTypeModal={setAssignTypeModal}
              setSystemMessageModal={setSystemMessageModal1}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default DriverDetails;
